export default "__VITE_ASSET__BDlLLAeD__"